import {
  CREATE_SEARCH,
  CREATE_SEARCH_SESSION,
} from 'actions/actionConstants'
import { createAppReducer } from 'lib/redux/reducerUtils'

export const initialSearchState: App.SearchState = {
  searches: {},
  searchSessions: {},
}

export default createAppReducer<App.SearchState>(initialSearchState, {
  [CREATE_SEARCH]: (state, action) => {
    const { key, searchId, searchContext, searchEvent } = action

    return {
      ...state,
      searches: {
        ...state.searches,
        [key]: {
          searchId,
          searchContext: searchContext ?? state.searches[key]?.searchContext,
          searchEvent,
        },
      },
    }
  },
  [CREATE_SEARCH_SESSION]: (state, action) => {
    const { key, searchSessionId } = action

    return {
      ...state,
      searchSessions: {
        ...state.searchSessions,
        [key]: { searchSessionId }
      },
    }
  },
})
